import z from "zod";
import { InstrumentApiRepository } from "./InstrumentApiRepository";

export const columns = [
    { header: "Nemotécnico", accessor: "mnemonic" },
    { header: "Tipo de instrumento", accessor: "instrumentType.name" },
    { header: "ISIN", accessor: "isin" },
    { header: "Moneda", accessor: "currency" },
    { header: "Tasa facial", accessor: "interestRate" },
    { header: "Periodicidad", accessor: "frequency" },
    { header: "Fecha emisión", accessor: "issuanceDate" },
    { header: "Fecha vencimiento", accessor: "maturityDate" },
    { header: "Emisor", accessor: "issuerName" },
    { header: "Calificación", accessor: "rating" },
];

export const schema = z.object({
    id: z.string().optional(),
    mnemonic: z.string(),
    instrumentType: z.string(),
    isin: z.string(),
    currency: z.string(),
    interestRate: z.string(),
    frequency: z.string(),
    issuanceDate: z.string(),
    maturityDate: z.string(),
    issuerName: z.string(),
    rating: z.string(),
});

export type InstrumentFormData = z.infer<typeof schema>;

export const instrumentRepository = new InstrumentApiRepository();

export const instrumentKeys = {
    all: ['instruments'] as const,
    details: (id: string) => [...instrumentKeys.all, id] as const,
    allInstrumentTypes: ['instrumentType'] as const,
};